import { render, staticRenderFns } from "./UnosPutnogNaloga.vue?vue&type=template&id=411a748f&"
import script from "./UnosPutnogNaloga.vue?vue&type=script&lang=ts&"
export * from "./UnosPutnogNaloga.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports